import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const MediaUsageGoalStore = create((set) => ({
    mediaUsageGoals: null,
    mediaUsageGoal: null,
    currentPage: 1,
    pageSize: 9,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.mediaUsageGoal[attributeName] = newValue;
            return { mediaUsageGoal: state.mediaUsageGoal };
        });
    },

    resetMediaUsageGoal: () => {
        set((state) => {
            return { mediaUsageGoal: {} };
        });
    },

    loadAll: (pageSize, currentPage, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'mediaUsageGoal/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    mediaUsageGoals: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'mediaUsageGoal/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ mediaUsageGoal: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'mediaUsageGoal/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    update: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'mediaUsageGoal/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'mediaUsageGoal/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default MediaUsageGoalStore;
